import React, { Component } from "react";
import {CallAPI, parseIntFromStr, GetTzAwareTime, GetCookieFunction, HandleTextChange} from '../../utils/util';
import {useLocation, useNavigate, useParams} from "react-router-dom";
import { PatientNav } from './patientnav';
import Alert from "react-bootstrap/Alert";

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();

        return (
            <Component
                {...props}
                router={{ location, navigate, params }}
            />
        );
    }
    return ComponentWithRouterProp;
}

class StartTreatment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            patientID: parseIntFromStr(this.props.router.params.patientId),
            orderFound: false
        };

        this.componentDidMount = this.componentDidMount.bind(this);
        this.handleTextChange = HandleTextChange.bind(this);
        this.beginTreatment = this.beginTreatment.bind(this);        
    };

    componentDidMount() {
        CallAPI({}, `patients/${this.state.patientID}/dialysisOrder`, 'GET', (res) => {
            const found = !!(res && res.Doctor_Fname);
            this.setState({ ...res, orderFound: found });

            // If dialysis order has not been added, then provide a warning
            if (!found){
                let msg = "Dialysis order for this patient has not yet been added. " +
                    ((GetCookieFunction("User").type === "doctor") ?
                    "Please use the edit icon below to add patient's dialysis order." :
                    "Please contact a doctor to have the order added for this patient.");
                this.setState({
                    "modalVariant": "danger",
                    "modalMessage": msg
                })
            }
        });
    }

    beginTreatment(e) {
        e.preventDefault()
        CallAPI({"weight" : this.state.weight}, `patients/${this.state.patientID}/startTreatment`, 'PUT', (res) => {
            if(!res || !res.success) {
                this.setState({
                    "modalVariant": "danger",
                    "modalMessage": res.message ?? "Could not perform operation."
                })
            } else {
                this.props.router.navigate(`/patients/${this.state.patientID}/profile`)
            }
        })
    }

    render = () => {
        return (
            <div>
                <PatientNav patientId={this.state.patientID} />
                <div className="ci-page">
                    <div className="ci-header">
                        <h2>Start Treatment</h2>
                        <p>Review dialysis order and begin treatment session</p>
                    </div>

                    {this.state.modalVariant && (
                        <Alert variant={this.state.modalVariant} className="ci-alert">
                            {this.state.modalMessage}
                            {(!this.state.orderFound && GetCookieFunction("User").type === "doctor") && (
                                <div style={{marginTop: '12px'}}>
                                    <a href={`/patients/${this.state.patientID}/dialysisorder`} style={{fontWeight: 600, color: 'inherit'}}>
                                        Create Dialysis Order →
                                    </a>
                                </div>
                            )}
                        </Alert>
                    )}

                    {this.state.orderFound && (
                        <form onSubmit={(e) => this.beginTreatment(e)}>
                            <div className="ci-section-title">Dialysis Order</div>
                            <div className="ci-card">
                                <dl className="profile-dl">
                                    <dt>Frequency</dt><dd>{this.state.Frequency} times/week</dd>
                                    <dt>Duration</dt><dd>{this.state.Duration} min</dd>
                                    <dt>Blood Flow Rate</dt><dd>{this.state.Blood_Flow} mL/min</dd>
                                    <dt>Dry Weight</dt><dd>{this.state.Dry_Weight} kg</dd>
                                    <dt>Dialysate Flow</dt><dd>{this.state.Dialysate_Flow} mL/min</dd>
                                    <dt>Dialyzer Type</dt><dd>{(this.state.Dialyzer_Type ?? "").replace("_", " ")}</dd>
                                    <dt>Sodium</dt><dd>{this.state.Sodium} mEq/L</dd>
                                    <dt>Potassium</dt><dd>{this.state.Potassium} mEq/L</dd>
                                    <dt>Calcium</dt><dd>{this.state.Calcium} mEq/L</dd>
                                    <dt>Bicarbonate</dt><dd>{this.state.Bicarbonate} mEq/L</dd>
                                    {this.state.Comments && <><dt>Notes</dt><dd>{this.state.Comments}</dd></>}
                                    <dt>Ordered by</dt><dd>{this.state.Doctor_Fname} {this.state.Doctor_Lname}</dd>
                                    <dt>Last edited</dt><dd>{GetTzAwareTime(this.state.Last_Edited_On, GetCookieFunction("User").tz)}</dd>
                                </dl>
                            </div>

                            <div className="ci-section-title">Begin Session</div>
                            <div className="ci-card">
                                <div className="ci-grid">
                                    <div className="ci-field">
                                        <label htmlFor="weight" className="ci-required-label">Patient's Weight (kg)</label>
                                        <input type="text" id="weight" name="weight" required
                                            pattern="^\d{1,3}(\.\d{0,2})?$"
                                            title="e.g. 65 or 65.5"
                                            placeholder="e.g. 65.5"
                                            onChange={(e) => this.handleTextChange(e)} />
                                    </div>
                                </div>
                            </div>

                            <div className="ci-submit-row">
                                <button type="submit" className="logSubmit ci-submit-btn">Start Treatment</button>
                            </div>
                        </form>
                    )}
                </div>
            </div>
        );
    };
}

export default withRouter(StartTreatment)